import React from "react"

import Modal from "@/components/core/Modal/Modal"
import EditProfileForm from "@/components/AccountSettings/v1/EditProfileForm"

import { addDataLayerEditProfile } from "@/components/AccountSettings/v1/EditProfile/analytics"
const EditProfile = ({
  show = false,
  onModalClose = () => {},
  i18n = {},
  data = {},
  userType = [],
  onEdit = () => {},
  businessList = [],
  ...props
}) => {
  const handleSubmitEditProfile = async (profileData, cb) => {
    const obj = {
      firstName: profileData?.firstName?.value,
      lastName: profileData?.lastName?.value,
      businessName: profileData?.businessName?.value,
      businessType: profileData?.businessType?.value,
      businessSubType: profileData?.businessSubType?.value,
      businessZipCode: profileData?.businessZipCode?.value,
      addressId: data?.profileAddrId,
    }
    onEdit(obj, onModalClose)
    addDataLayerEditProfile()
  }

  return (
    <Modal
      onModalClose={onModalClose}
      showModal={show}
      modalTitle={i18n?.editProfile}
    >
      <div className="edit-profile-modal" aria-labelledby="edit-profile-label">
        {
          <div id="edit-profile-label" className="edit-profile__title">
            <span>{i18n?.editProfile}</span>
          </div>
        }
        {
          <EditProfileForm
            showModal={show}
            i18n={i18n}
            data={data}
            {...props}
            userType={userType}
            businessList={businessList}
            onEdit={(profileData, cb) =>
              handleSubmitEditProfile(profileData, cb)
            }
            addDataLayerEditProfile={errMessages =>
              addDataLayerEditProfile(errMessages)
            }
          />
        }
      </div>
    </Modal>
  )
}

export default EditProfile
